import { LoadingButton } from '@atoms/buttons';
import { FaIcon } from '@atoms/icons';
import { ShiftOld } from '@libs/models/shifts/shift';
import { useRotationDrawerState, useSeriesDrawerState } from '@libs/store/shifts';
import { Box, Stack } from '@mui/material';
import { ShiftAssigneeButton } from '@pages/schedule/components';

type AssigneeColumnProps = {
  shift: ShiftOld;
};
export function AssigneeColumn({ shift }: AssigneeColumnProps) {
  const disableUnassign = ['InProgress', 'Completed', 'Canceled', 'Expired'].includes(shift.status);
  const disableAssign = ['Canceled', 'Expired'].includes(shift.status);
  const [openSeriesDrawer] = useSeriesDrawerState();
  const [openRotationDrawer] = useRotationDrawerState();

  const isRecurrencePart = shift.recurrence !== 'single';
  const isSingleAssignee = isRecurrencePart && shift.canHasMultipleAssignee === false;

  const handleOpenRecurrence = () => {
    shift.recurrence === 'series' && openSeriesDrawer('' + shift.recurrenceId);
    shift.recurrence === 'rotation' && openRotationDrawer('' + shift.recurrenceId);
  };

  if (isSingleAssignee) {
    return (
      <LoadingButton
        id="assign"
        onClick={(event) => {
          event.stopPropagation();
          handleOpenRecurrence();
        }}
        rounded
        fullWidth={false}
        disabled={disableAssign}
      >
        <Stack direction="row" alignItems="center">
          <Box fontSize={16} mr={1} ml={1}>
            <FaIcon name="user-magnifying-glass" color={disableAssign ? 'action.disabled' : 'primary.main'} />
          </Box>
          Open recurrence
        </Stack>
      </LoadingButton>
    );
  }

  return (
    <ShiftAssigneeButton
      shift={{ ...shift, assignees: shift.assignee ? [{ ...shift.assignee }] : [] }}
      disabled={shift.assignee ? disableUnassign : disableAssign}
    />
  );
}
